import React from 'react';
import NavBar from '../components/NavBar';
import '../styles/sitePages.css';
import './Contact.css';
import { Helmet } from 'react-helmet-async';

function Contact() {
  const handleFormSubmit = (e) => {
    // Track contact form submission event in Google Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'contact_form_submit', {
        'event_category': 'engagement',
        'event_label': 'contact_page'
      });
    }
  };

  return (
    <div>
      <Helmet>
        <title>Contact Logic Puzzles - Get in Touch with Our Team</title>
        <meta name="description" content="Have questions about our logic puzzle games? Contact the Logic Puzzles.ca team! We welcome feedback, suggestions, and questions about our brain-teasing puzzle collection. Get in touch today!" />
        <link rel="canonical" href="https://logicpuzzles.ca/contact" />
        <meta property="og:title" content="Contact Logic Puzzles - Get in Touch with Our Team" />
        <meta property="og:description" content="Have questions about our logic puzzle games? Contact the Logic Puzzles.ca team!" />
        <meta property="og:url" content="https://logicpuzzles.ca/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://logicpuzzles.ca/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Logic Puzzles - Get in Touch with Our Team" />
        <meta name="twitter:description" content="Have questions about our logic puzzle games? Contact the Logic Puzzles.ca team!" />
        <meta name="twitter:image" content="https://logicpuzzles.ca/og-image.png" />
      </Helmet>
      <NavBar />
      <div className="contact-page">
        <header className="sp-hero">
          <div className="container">
            <span className="eyebrow">Get in touch</span>
            <h1>Contact Us</h1>
            <p className="sp-hero__lead">
              Have questions, suggestions, or feedback? We'd love to hear from you! Whether you've found a bug, have an idea for a new puzzle type, or just want to say hello, we read every message and aim to respond within 48 hours.
            </p>
          </div>
        </header>

        <div className="container sp-main">
          <div className="contact-layout">
            <div className="contact-form-container">
              <h2>Send Us a Message</h2>
              <form
                action="https://formspree.io/f/xwpledkp"
                method="POST"
                className="contact-form"
                onSubmit={handleFormSubmit}
              >
                <div className="form-group">
                  <label htmlFor="email">Your Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder="Enter your email address"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Your Message</label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    placeholder="What would you like to tell us?"
                    rows="6"
                  ></textarea>
                </div>

                <button type="submit" className="button submit-button">Send Message</button>
              </form>
            </div>

            <div className="contact-channels">
              <div className="contact-channel">
                <h3>Email Us Directly</h3>
                <p>For general inquiries, bug reports, or partnership opportunities:</p>
                <p><a href="mailto:ben@sparkandspiral.ca">ben@sparkandspiral.ca</a></p>
              </div>
              <div className="contact-channel">
                <h3>Join Our Community</h3>
                <p>Chat with other puzzle enthusiasts and share solving strategies:</p>
                <p><a href="https://discord.gg/Vh27jjmMBS" target="_blank" rel="noopener noreferrer">Discord Server</a></p>
              </div>
              <div className="contact-channel">
                <h3>Follow Us</h3>
                <p>Stay updated on new puzzles, features, and behind-the-scenes content:</p>
                <p>
                  <a href="https://www.instagram.com/sparkandspiralsoftware" target="_blank" rel="noopener noreferrer">Instagram</a>
                  {' · '}
                  <a href="https://www.tiktok.com/@sparkandspiralsoftware" target="_blank" rel="noopener noreferrer">TikTok</a>
                  {' · '}
                  <a href="https://www.youtube.com/@sparkandspiralsoftware" target="_blank" rel="noopener noreferrer">YouTube</a>
                </p>
              </div>
            </div>
          </div>

          <section className="contact-faq">
            <h2>Frequently Asked Questions</h2>
            <div className="contact-faq-grid">
              <div className="contact-faq-item">
                <h3>How do I report a bug?</h3>
                <p>Use the form above or email us with a description of what happened, which game you were playing, and the device and browser you were using. Screenshots are always helpful.</p>
              </div>
              <div className="contact-faq-item">
                <h3>Can I suggest a new puzzle type?</h3>
                <p>Absolutely! We love hearing puzzle suggestions from our community. Send us the name of the puzzle or describe the rules and we'll add it to our list of games to consider.</p>
              </div>
              <div className="contact-faq-item">
                <h3>Are your games available as mobile apps?</h3>
                <p>Yes! Several of our puzzles are available on iOS and Android. Visit our <a href="/apps">Apps page</a> for download links and details.</p>
              </div>
              <div className="contact-faq-item">
                <h3>Do you offer puzzles for classrooms or educational use?</h3>
                <p>Our <a href="/printable/sudoku">printable puzzles</a> are popular with teachers and tutors. All our web-based games are free to use in educational settings. If you need something specific, get in touch and we'll see how we can help.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Contact; 